<template>
  <div class="h-full w-full flex items-center justify-center" :class="center && 'text-center'">
    <div ref="container" class="p-6 lg:p-12 max-w-[668px]">
      <h1 class="font-bold text-4xl xl:text-5xl mt-4 leading-tight xl:leading-tight" :class="animateClass">{{title}}</h1>
      <p v-if="subtitle" class="text-lg lg:text-xl font-semibold mt-1" :class="animateClass">{{subtitle}}</p>
      <slot/>
    </div>
  </div>
</template>

<script setup>
import {ref} from "vue";
import {useAnimateInTrigger} from "../composables/AnimateInComposable";

defineProps({
  title: String,
  subtitle: String,
  center: Boolean,
});

const container = ref();
const animateClass = ref("animate-in-vars-pre");

useAnimateInTrigger(container, (className) => animateClass.value = className);
</script>
